import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import backArrow from "../../../assets/images/navigate-back.svg";
import styles from "./index.module.scss";
import { Breadcrumbs, Typography } from "@mui/material";

type BreadcrumbProps = {
  items: { label: string; path?: string }[];
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const location = useLocation();
  const navigate = useNavigate();

  console.log(location.pathname, "location.pathname");
  return (
    <div className={styles.breadcrumb}>
      <img
        src={backArrow}
        alt=""
        className={styles.arrow}
        onClick={() => navigate(-1)}
      />
      <Breadcrumbs maxItems={2} aria-label="breadcrumb">
        {items.map((item, index) => {
          const isActive = location.pathname === "joinwithothers";
          if (item.path) {
            return (
              <Link
                key={index}
                to={item.path}
                className={`${styles.link} ${isActive ? styles.linkActive : ""}`}
              >
                {item.label}
              </Link>
            );
          } else {
            return (
              <Typography key={index} className={styles.linkActive}>
                {item.label}
              </Typography>
            );
          }
        })}
      </Breadcrumbs>
    </div>
  );
};

export default Breadcrumb;
